import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const ProblemContainer = styled.section`
  padding: 120px 5% 80px;
  background: #0a0a0a;
  
  @media (max-width: 768px) {
    padding: 80px 20px 60px;
  }
`;

const ProblemContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: left;
`;

const SectionHeader = styled.div`
  margin-bottom: 80px;
  display: flex;
  justify-content: flex-start;
`;

const HeaderContent = styled.div`
  text-align: left;
  max-width: 500px;
`;

const SectionTitle = styled(motion.h2)`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-size: clamp(28px, 3.5vw, 40px);
  font-weight: 400;
  color: white;
  line-height: 1.3;
  letter-spacing: -0.01em;
  margin-bottom: 16px;
`;

const SectionSubtitle = styled(motion.p)`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-size: 15px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.6;
  margin: 0;
`;

const ProblemsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 60px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

const ProblemCard = styled(motion.div)`
  text-align: left;
`;

const ProblemTitle = styled.h3`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: white;
  margin-bottom: 12px;
  line-height: 1.4;
`;

const ProblemDescription = styled.p`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.6;
  margin: 0;
`;

const ProblemSection = () => {
  const problems = [
    {
      title: "Scattered across platforms",
      description: "Your streaming data is on Spotify, booking info is in emails, fan engagement is on social media, and revenue tracking is in spreadsheets. Nothing connects."
    },
    {
      title: "Manual busy work",
      description: "Checking royalty payments, submitting to playlists, following up on opportunities, and tracking deadlines. Hours of work that could be automated."
    },
    {
      title: "Missing opportunities",
      description: "Playlist submission deadlines pass by, sync licensing opportunities expire, and collaboration requests get buried in your inbox while you're focused on creating."
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <ProblemContainer>
      <ProblemContent>
        <SectionHeader>
          <HeaderContent>
            <SectionTitle
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            >
              The music industry is complex enough
            </SectionTitle>
          </HeaderContent>
        </SectionHeader>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <ProblemsGrid>
            {problems.map((problem, index) => (
              <ProblemCard
                key={index}
                variants={itemVariants}
              >
                <ProblemTitle>{problem.title}</ProblemTitle>
                <ProblemDescription>{problem.description}</ProblemDescription>
              </ProblemCard>
            ))}
          </ProblemsGrid>
        </motion.div>
      </ProblemContent>
    </ProblemContainer>
  );
};

export default ProblemSection; 